/**
 * Prüft, wohin nach der Anmeldung gesprungen werden darf.
 *
 * Der Wert kommt aus `?redirect-to=` und damit aus der Adresszeile — also aus
 * der Hand desjenigen, der den Link geschickt hat. Ungeprüft übernommen wäre
 * das ein offener Redirect: Ein Link auf
 * `https://olgen.online/login?redirect-to=https://boese.example` sähe für den
 * Kunden echt aus, er meldet sich bei uns an und landet danach woanders.
 *
 * Erlaubt ist deshalb ausschließlich ein Pfad auf dieser Seite.
 */

/** Wohin es geht, wenn nichts oder nichts Erlaubtes angegeben ist. */
export const STARTSEITE = "/";

export function sicheresZiel(rohwert: string | undefined): string {
	if (rohwert === undefined || rohwert === "") {
		return STARTSEITE;
	}

	// Muss mit genau einem Schrägstrich beginnen. `//boese.example` wäre eine
	// protokollrelative URL und damit ein Sprung auf eine fremde Seite —
	// obwohl es wie ein Pfad aussieht.
	if (!rohwert.startsWith("/") || rohwert.startsWith("//")) {
		return STARTSEITE;
	}

	// Auch ein Backslash an dieser Stelle wird von Browsern als Trenner
	// gelesen, `/\boese.example` landet also ebenfalls auswärts.
	if (rohwert.startsWith("/\\")) {
		return STARTSEITE;
	}

	// Ein Doppelpunkt vor dem nächsten Schrägstrich wäre ein Schema.
	const naechsterSchraegstrich = rohwert.indexOf("/", 1);
	const kopf =
		naechsterSchraegstrich === -1 ? rohwert.slice(1) : rohwert.slice(1, naechsterSchraegstrich);

	if (kopf.includes(":")) {
		return STARTSEITE;
	}

	// Wieder auf die Anmeldeseite zu schicken wäre eine Schleife.
	if (rohwert === "/login" || rohwert.startsWith("/login?")) {
		return STARTSEITE;
	}

	return rohwert;
}
